import GameDetailComponent from '@components/game-detail';
import * as React from 'react';

export interface IGameDetailProps {}

export default function GameDetail(props: IGameDetailProps) {
  return <GameDetailComponent />;
}
